import { render, staticRenderFns } from "./FormSaveTransfer.vue?vue&type=template&id=5da3da3a&scoped=true"
import script from "./FormSaveTransfer.vue?vue&type=script&lang=js"
export * from "./FormSaveTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da3da3a",
  null
  
)

export default component.exports